<template>
  <v-chip class="similarity-chip" :class="chipClass">
    <span class="mr-1">Similarity:</span>
    <span>{{ scorePct }}%</span>
  </v-chip>
</template>

<script>
export default {
  name: 'SimilarityChip',
  props: {
    score: {
      type: Number,
      required: true,
    },
  },
  computed: {
    chipClass() {
      if (this.score >= 0.9) {
        return 'high';
      } else if (this.score >= 0.6) {
        return 'medium';
      } else {
        return 'low';
      }
    },
    scorePct() {
      return (this.score * 100).toFixed(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.similarity-chip {
  display: flex;
  justify-content: center;
  min-width: 110px;

  color: white;
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;

  &.high {
    background-color: #71d4b7;
  }
  &.medium {
    background-color: #ffc634;
  }
  &.low {
    background-color: #ff879e;
  }
}
</style>
